import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";

import { FeatureFlags } from "src/common/types";

export const useFlags = () => {
  const flags: FeatureFlags = useLDFlags();

  return flags;
};
